import { Control, Controller, FieldValues, useFormContext } from 'react-hook-form';
import { Box, Button, Grid2 } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { ILooseObject } from '@/src/types/common.interface';
import { IAttributeDef } from '@/src/config/AttributesConfig';
import MetaInputValues from '@/src/components/MetaInputValues';

type UserMetaDataRowProps = {
  userAttributesDefinition: IAttributeDef[];
  fields: ILooseObject[];
  append: (row: ILooseObject) => void;
  remove: (id: number) => void;
  defaultMetaRow: () => ILooseObject;
  control: Control<FieldValues>;
  clearErrors: (name: string) => void;
  disabled?: boolean;
  errors?: ILooseObject;
  setValue?: (name: string, value: any) => void;
};

const UserMetaDataRow = ({
  userAttributesDefinition,
  clearErrors,
  fields,
  append,
  remove,
  control,
  defaultMetaRow,
  disabled = false,
  errors,
  setValue
}: UserMetaDataRowProps) => {
  const formContext = useFormContext();
  const setValueFunction = setValue || formContext?.setValue;

  return (
    <Box height="100%">
      <Grid2 container columnSpacing={5} rowSpacing={5}>
        {fields.map((field, index) => (
          <Grid2 size={6} key={field.id}>
            <Controller
              control={control}
              name={`metadata.${index}`}
              render={({ field: { name } }) => {
                return (
                  <MetaInputValues
                    handleOnDelete={() => remove(index)}
                    disabled={disabled}
                    availableAttributes={userAttributesDefinition}
                    allFields={fields}
                    currentIndex={index}
                    errors={errors?.[index] || {}}
                    control={control}
                    fieldName={name}
                    onAttributeChange={(fieldName, value) => {
                      setValueFunction?.(fieldName, value);
                    }}
                    clearErrors={clearErrors}
                  />
                );
              }}
            />
          </Grid2>
        ))}
      </Grid2>
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
        <Button
          variant="outlined"
          onClick={() => append(defaultMetaRow())}
          sx={{ textTransform: 'none' }}
          size="small"
          startIcon={<AddIcon />}
          disabled={disabled || fields.length >= userAttributesDefinition.length}
        >
          Add row
        </Button>
      </Box>
    </Box>
  );
};

export default UserMetaDataRow;
